import { ChipColors } from './Chip.types';

export const getChipColor = (color: ChipColors) => {
  switch (color) {
    case ChipColors.Success:
      return 'chip--success';
    case ChipColors.Info:
      return 'chip--info';
    case ChipColors.Alert:
      return 'chip--alert';
    case ChipColors.Warning:
      return 'chip--warning';
    case ChipColors.Neutral:
      return 'chip--neutral';
    case ChipColors.Primary:
      return 'chip--primary';
    case ChipColors.Secondary:
      return 'chip--secondary';
    default:
      return 'chip--primary';
  }
};
